const CredentialWizardButtons = ({ children, text }) => {
  const termsText = text || 'By connecting you agree with our';
  return (
    <div className="credential-wizard-buttons">
      <div className="button-row">{children}</div>
      <p className="terms-text">
        {termsText}{' '}
        <a href="https://mindcloud.co/terms-of-use" target="_blank" rel="noopener noreferrer">
          Terms of Use
        </a>{' '}
        and{' '}
        <a href="https://mindcloud.co/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default CredentialWizardButtons;
